import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "item-sku-attrs" }
const _hoisted_2 = {
  key: 0,
  class: "item-sku-attrs-detail"
}

import { PropType } from 'vue';
import { OioInput } from '@kunlun/vue-ui-antd';
import { ViewType } from '@kunlun/dependencies';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemSkuAttrs',
  props: {
  value: {
    type: Array as PropType<{ attrName: string; attrValue: string }[]>,
    default: () => []
  },
  viewType: {
    type: String as PropType<ViewType>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (__props.viewType === _unref(ViewType).Detail)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.attrValue), 1))
          : (_openBlock(), _createBlock(_unref(OioInput), {
              key: 1,
              placeholder: "规格值",
              value: item.attrValue,
              "onUpdate:value": ($event: any) => ((item.attrValue) = $event)
            }, null, 8, ["value", "onUpdate:value"]))
      ], 64))
    }), 128))
  ]))
}
}

})